import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { GridAllModule, GridModule } from "@syncfusion/ej2-angular-grids";
import { MaskedTextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { CalendarModule } from "angular-calendar";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { EmployeeAgreementModule } from "../employee-agreement/employee-agreement.module";
import { EmployeeAgreementlistRoutingModule } from "./employee-agreementlist-routing.module";
import { EmployeeAgreementlistComponent } from "./employee-agreementlist.component";
import { EmployeePayrollService } from "../employee/employee-payroll/employee-payroll.service";
import { ClientEmployeeDynamicFormModule } from "../client-employee-dynamicform/client-employee-dynamicform.module";
import { DropDownListAllModule } from "@syncfusion/ej2-angular-dropdowns";
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';

@NgModule({
declarations:[EmployeeAgreementlistComponent],
imports:[
    CommonModule,
    FormsModule,
    CalendarModule,
    GridModule,
    GridAllModule,
    NgSelectModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    ReactiveFormsModule,
    EmployeeAgreementlistRoutingModule,
    EmployeeAgreementModule,
    PDFExportModule,
    ClientEmployeeDynamicFormModule,
    DropDownListAllModule,
    DropDownListModule
],

    exports:[EmployeeAgreementlistComponent],
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
    providers:[EmployeePayrollService]
})

export class EmployeeAgreementlistModule{}